{
  "completed": "Valmistunut: ",
  "current": "Nykyinen: ",
  "notCompleted": "Ei valmis: ",
  "steplist": "Vaiheluettelo"
}
